module.exports = __webpack_public_path__ + "static/media/logo.100fc49a.svg";